import { ReactElement, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { IWidget } from "../../../../services/http/widget/models/IWidget";
import { useDependency } from "../../../../contexts/DependencyContext";
import { WidgetService } from "../../../../services/widgets/WidgetService";
import { ComponentModelService } from "../../../../services/ComponentModelService";
import { className } from "../../../../shared/helpers";
import styles from "./SidebarWidget.module.scss";
import { WidgetTypes } from "../../../../services/http/widget/models/WidgetTypes";
import { IButtonProperties } from "../../../../services/widgets/BaseWidgetService";

interface SidebarItemProps
{
    index: number;
    widget: IWidget;
    visualClasses: string;
}

const SidebarWidget = (props: SidebarItemProps): ReactElement =>
{
    const widgetService = useDependency(WidgetService);
    const service = useDependency(ComponentModelService);
    const { component, rootComponentChildren } = service.componentModel;
    const history = useHistory();
    const widget = props.widget;
    const [buttonProperties, setButtonProperties] = useState<IButtonProperties>({} as any);

    useEffect(() => {
        const weatherComponent = rootComponentChildren.find(comp => comp.code.toLowerCase().indexOf("weather") && comp.componentTypeId === 2);
        const weatherWidget = widget.widgetType === WidgetTypes.Weather ? widget : null;
        if (weatherComponent && weatherWidget)
            weatherWidget.uiConfiguration = widgetService.updateUiConfig(weatherWidget.uiConfiguration, weatherComponent.id, "weatherComponentId");
        setButtonProperties(widgetService.getButtonProperties(widget, component.id));
    }, [rootComponentChildren, widgetService, widget, component.id]);

    return (
        <article
            {...className(styles.sidebarWidget, props.visualClasses)}
            style={{ animationDelay: `${props.index * 50}ms` }}
        >
            {/*-- Header --*/}
            <div className={styles.header}>
                <div className={styles.heading}>
                    <h3>{widget.name}</h3>

                    {widgetService.widgetHasBadge(widget.widgetTypeId) && (
                        <div className={styles.badge}>
                            {widgetService.getBadgeText(widget.widgetTypeId)}
                        </div>
                    )}
                </div>

                {buttonProperties && buttonProperties.text !== '' && (
                    <button className="btn btn-sm" onClick={() => history.push(buttonProperties.url)}>
                        {buttonProperties.text}
                    </button>
                )}
            </div>

            {/*-- Body --*/}
            <div className={styles.sidebarWidgetBody}>
                {widgetService.getWidgetBody(widget)}
            </div>
        </article>
    );
};

export default SidebarWidget;
